import React, { useContext, useEffect, useState } from "react";
import "./Customisation_Product.css";
import Heading_banner_section from "../common_components/heading_banner/Heading_banner_section";
import Your_Idea from "../common_components/your_Idea/Your_Idea";
import Customisation_Product_Form from "./Customisation_Product_Form/Customisation_Product_Form";
import How_costomization_works from "../offerings/gift_customisation/how_costomization_works/How_costomization_works";
import Personalise_Gift_Swiper from "../offerings/gift_customisation/personalise_gift_swiper/Personalise_Gift_Swiper";
import { Context } from "../../utils/context";
import { getProductDetail } from "../../utils/luxuryapis/Product/Product";
import { useParams, useSearchParams } from "react-router-dom";

const Customisation_Product = () => {

   const [searchParams] = useSearchParams();
  
    const subVariantId = searchParams.get("subVariant_id");
    const variantId = searchParams.get("variant_id");
   const { id } = useParams();
   const { IMG_URL } = useContext(Context);
    const [product, setproduct] = useState();
     const getAllData = async (id) => {
    let res = await getProductDetail(id);
    if (res?.success) {
      setproduct(res?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };
  useEffect(() => {
    getAllData(id);
  }, [id]);

  
  
  return (
    <section className="Gift_Customisation">
      <Heading_banner_section
        headingText={"GIFT CUSTOMISATION"}
        subHeadingText={"Make your gift unique with a personal touch"}
      />
      <div className="customisation_div">
        <Customisation_Product_Form product={product} variantId={variantId} subVariantId={subVariantId} />
      </div>

      <div className="bottom_div">
        <Personalise_Gift_Swiper product={product} />
      </div>

      <How_costomization_works product={product} />

      <Your_Idea btnText={"Customize Bespoke Gifts"}/>
    </section>
  );
};

export default Customisation_Product;
